import { watch } from 'vue'

import { useAccessStore } from '@vben/stores'

import { useMenuBadgeDict } from '#/dict/modules/common/menu-badge'
import { isInMicroApp } from '#/micro-app'
import { useMenuBadgeStore } from '#/store/menu-badges'

export function useMenuBadges(): void {
  if (isInMicroApp()) return

  const accessStore = useAccessStore()
  const badgeStore = useMenuBadgeStore()
  const badgeDict = useMenuBadgeDict()

  watch(
    [() => accessStore.accessToken, () => accessStore.isAccessChecked],
    ([token, ready]) => {
      badgeStore.$reset()
      if (token && ready) void badgeStore.refresh()
    },
    { immediate: true },
  )

  watch(
    [() => accessStore.accessMenus, () => badgeStore.items],
    () => {
      accessStore.$patch(() => {
        for (const { path, value } of badgeDict.menus) {
          const menu = accessStore.getMenuByPath(path)
          if (!menu) continue
          const count = badgeStore.items.find(
            (item) => item.code === value,
          )?.count
          menu.badge =
            typeof count === 'number' && Number.isInteger(count) && count > 0
              ? String(count)
              : undefined
          menu.badgeType = 'normal'
          menu.badgeVariants = 'destructive'
        }
      })
    },
    { immediate: true },
  )
}
